import Loader from 'components/Loader'
import React from 'react'
import styled, { keyframes } from 'styled-components'
import { ReactComponent as BoxyLogo } from 'assets/svg/logo-purple.svg'

interface Props {
  height?: string
}

const bouncingLogo = keyframes`
    0%   { transform: scale(1,1)      translateY(0); }
    10%  { transform: scale(1.1,.9)   translateY(0); }
    30%  { transform: scale(.9,1.1)   translateY(-100px); }
    50%  { transform: scale(1.05,.95) translateY(0); }
    57%  { transform: scale(1,1)      translateY(-7px); }
    64%  { transform: scale(1,1)      translateY(0); }
    100% { transform: scale(1,1)      translateY(0); }
`
const LogoWrapper = styled.div<{ height: string }>`
  display: flex;
  justify-content: center;
  height: ${({ height }) => height};
  overflow: hidden;
  align-items: center;

  svg {
    animation: ${bouncingLogo} 1s cubic-bezier(0.46, 0.03, 0.52, 0.96) infinite -1s;
  }
`
const Fallback = ({ height = '100vh' }: Props) => {
  return (
    <LogoWrapper height={height}>
      <BoxyLogo width={120} />
    </LogoWrapper>
  )
}

export default Fallback
